"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SortingOrder;
(function (SortingOrder) {
    SortingOrder["Asc"] = "asc";
    SortingOrder["Desc"] = "desc";
})(SortingOrder = exports.SortingOrder || (exports.SortingOrder = {}));
//# sourceMappingURL=Sort.js.map